import { z } from "zod";

export enum TouchPoint {
  CDC = "cdc",
  DESKTOP = "desktop",
  MOBILE = "mobile",
}

export const TouchPointSchema = z.enum(TouchPoint);

/**
 * BE / DB と共有するチャネル語彙（order_channel_code_type: CDC / Web / App）。
 * X-Touchpoint ヘッダはこの値で送り、BE は変換せずそのまま扱う。
 * FE 内部のデバイス表現（{@link TouchPoint}）とは層を分け、境界で写像する。
 */
export enum TouchpointChannel {
  CDC = "CDC",
  WEB = "Web",
  APP = "App",
}

const TOUCH_POINT_TO_CHANNEL: Record<TouchPoint, TouchpointChannel> = {
  [TouchPoint.CDC]: TouchpointChannel.CDC,
  [TouchPoint.DESKTOP]: TouchpointChannel.WEB,
  [TouchPoint.MOBILE]: TouchpointChannel.APP,
};

/** FE 内部のデバイス表現を、BE 共有のチャネル値へ写像する。 */
export const toTouchpointChannel = (
  touchPoint: TouchPoint,
): TouchpointChannel => TOUCH_POINT_TO_CHANNEL[touchPoint];
